import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';

import Field from '../../util/field/Field';


const GRAL_FIELDS = Yup.object().shape({
    nombre : Yup.string().trim().min(3, 'Requiere al menos 3 caracteres').max(60, 'Ha excedido el límite de 60 caracteres.').required("El campo 'Nombre' es requerido."),
    crCaffenio:  Yup.string().trim().min(3, 'Requiere al menos 5 caracteres').max(15, 'Ha excedido el límite de 15 caracteres.').required("El campo 'CR INTERNO' es requerido."),
    segmentoId: Yup.object().required("El campo 'Segmento' es requerido.").nullable(),
    carriles : Yup.number().max(9, 'Ha excedido el valor máximo.').required("El campo '# Carriles' es requerido."),  
    activo: Yup.bool(),
    ventasMovil: Yup.bool(),
    restrictRefill: Yup.bool(),
    cerrado: Yup.bool(),
    operando: Yup.bool(),
    FechaApertura: Yup.string().required("El campo 'Fecha de apertura' es requerido."), 
    FechaCierre: Yup.string().nullable().when("cerrado", {
        is: true,
        then: Yup.string().required("El campo 'Fecha de cierre' es requerido."),
        otherwise: Yup.string().strip()
    }), 
    //Campos requeridos depende el segmento
    email: Yup.string().nullable().when("segmentoId.Segment", {
        is: (val) =>  {
            let valid = val && ["085", "078"].includes(val)
            return valid } ,
        then: Yup.string().trim().email('Formato no válido').required("El campo 'Correo' es requerido."),
        otherwise: Yup.string().strip()
    }),    
    centroSAP: Yup.string().nullable().when("segmentoId.Segment", {
        is: (val) => {
            let valid = val && ["085", "078"].includes(val)
            return valid } ,
        then: Yup.string().trim().min(3, 'Requiere al menos 3 caracteres').max(5, 'Ha excedido el límite de 5 caracteres.').required("El campo 'Centro SAP' es requerido."),
        otherwise: Yup.string().strip()
    }),
    
    CR:  Yup.string().nullable().when("segmentoId.Segment", {
        is: (val) => {
            let valid = val && ["086"].includes(val)
            return valid  },
        then: Yup.string().trim().min(3, 'Requiere al menos 3 caracteres').max(10, 'Ha excedido el límite de 10 caracteres.').required("El campo 'CR' es requerido."),
        otherwise: Yup.string().strip().nullable()
    }),
        
    cteSAP:Yup.string().nullable().when("segmentoId.Segment", {
        is: (val) => {
            let valid = val && ["086"].includes(val)
            return valid  },
        then: Yup.string().trim().min(5, 'Requiere al menos 5 caracteres').max(25, 'Ha excedido el límite de 25 caracteres.').required("El campo 'Centro SAP' es requerido."),
        otherwise: Yup.string().strip().nullable()
    }),
    destMercanciaSAP:Yup.string().nullable().when("segmentoId.Segment", {
        is: (val) => {
            let valid = val && ["086"].includes(val)
            return valid
        } ,
        then: Yup.string().trim().min(5, 'Requiere al menos 5 caracteres').max(25, 'Ha excedido el límite de 25 caracteres.').required("El campo 'Destinatario mercancía' es requerido."),
        otherwise: Yup.string().strip().nullable()
    }),
});




const hrWithLegend = (text, bold, textAlign) => {
    return (
        <div style={{
            "marginTop": 20,
            "marginBottom": 20,
            "marginLeft": textAlign && textAlign !== 'center' ? 20 : 0,
            "border": 0,
            "borderTop": '1px solid #eee',
            "textAlign": textAlign || 'center',
            "height": 0,
            "lineHeight": 0
        }} className="hr">
            {
                text &&
                <span className="category" style={{
                    "backgroundColor": '#fff',
                    "paddingLeft": 20,
                    "paddingRight": 20,
                    "fontSize": 16,
                    "fontWeight": bold ? "bold" : "normal"
                }}>
                    {
                        text
                    }</span>
            }

        </div>
    )
}
// Solo permite números, sin signos ni exponenciales
const onKeyPressNumber = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (/\+|-|e|E|\./.test(keyValue) || event.target.value.length >= event.target.getAttribute('maxLength'))
    event.preventDefault();
}


/**
 * Formulario con la información general del folio
 */
export const StepInfoDrive = ({ ...props }) => {
    const [puntoVenta, setPuntoVenta]  = useState({
        nombre : null,
        crCaffenio: null,
        segmentoId : null,
        carriles: null,
        activo: false,
        ventasMovil: false,
        restrictRefill: false,
        cerrado: false,
        operando : false,
        FechaApertura: null,
        FechaCierre: null,
        email: null,
        centroSAP: null,
        cr: null,
        cteSAP:null,
        destMercanciaSAP: null
    });
    const [segmentos, setSegmentos]  = useState([]);

    useEffect(() => {
        let pdv = {...props.caffenio}
        let arrSegmentos = [...props.segmentos]   

        pdv.FechaApertura = pdv.FechaApertura? moment(pdv.FechaApertura, "DD/MM/YYYY").toDate(): "";
        pdv.FechaCierre = pdv.FechaCierre? moment(pdv.FechaCierre, "DD/MM/YYYY").toDate() : "";
        pdv.segmentoId = arrSegmentos.find(val => val.SegmentId == pdv.segmentoId)
        
        setPuntoVenta(pdv);
        setSegmentos(arrSegmentos.map(s=> {s.label = s.Name ; s.value = s.SegmentId; return s;}));
    }, [])

    const FieldsBySegmento = (values, errors, touched,  handleChange, onKeyPressNumber) => {
        if (values && values.segmentoId){
            let segmento = segmentos.filter(s=> s.SegmentId == values.segmentoId.value)
            if (segmento && segmento.length > 0 && ['085', '078'].includes(segmento[0]['Segment'])){
               
                return driveFields(values, errors, touched,  handleChange, onKeyPressNumber)
            }
            if (segmento && segmento.length > 0 && segmento[0]['Segment'] == '086'){
                
                return barrasFields(values, errors, touched,  handleChange, onKeyPressNumber)}
        }
        return ""
    }

    const barrasFields = (values, errors, touched,  handleChange, onKeyPressNumber) => {
        return <div className="columns is-multiline">
            
        <div className="column is-4">
            <Field label="CR Oxxo"
                hasError={errors.CR}
                msgError={errors.CR && errors.CR ? errors.CR : ""}>
                <input
                    className="input"
                    label="CR"
                    name="CR"
                    value={values.CR}
                    onChange={(e) => handleChange(e)}

                />
            </Field>
        </div>
        <div className="column is-4">
            <Field label="Cliente SAP"
                hasError={errors.cteSAP}
                msgError={errors.cteSAP && errors.cteSAP ? errors.cteSAP : ""}>
                <input
                    className="input"
                    type="number"
                    min="0"
                    label="cteSAP"
                    name="cteSAP"
                    onKeyPress={onKeyPressNumber}
                    value={values.cteSAP}
                    onChange={(e) => handleChange(e)}
                />
            </Field>
        </div>
        <div className="column is-4">
            <Field label="Destinatario SAP"
                hasError={errors.destMercanciaSAP}
                msgError={errors.destMercanciaSAP && errors.destMercanciaSAP ? errors.destMercanciaSAP : ""}>
                <input
                    className="input"
                    type="number"
                    min="0"
                    label="destMercanciaSAP"
                    name="destMercanciaSAP"
                    onKeyPress={onKeyPressNumber}
                    value={values.destMercanciaSAP}
                    onChange={(e) => handleChange(e)}
                />
            </Field>
        </div>
    </div>

    }

    const driveFields = (values, errors, touched,  handleChange) => {
        return <div className="columns is-multiline">
                
                <div className="column is-6">
                    <Field label="Correo"
                        hasError={errors.email }
                        msgError={errors.email && errors.email ? errors.email : ""}>
                        <input
                            className="input"
                            label="email"
                            name="email"
                            value={values.email}
                            onChange={(e) => handleChange(e)}
                        />
                    </Field>
                </div>
                <div className="column is-3">
                    <Field label="Centro SAP"
                        hasError={errors.centroSAP }
                        msgError={errors.centroSAP && errors.centroSAP ? errors.centroSAP : ""}>
                        <input
                            className="input"
                            label="centroSAP"
                            name="centroSAP"
                            value={values.centroSAP}
                            onChange={(e) => handleChange(e)}
                        />
                    </Field>
                </div>
            </div>

    }

    const mapValues= (values)=>{
        let caffenioUpdated = {...values};
        caffenioUpdated.segmentoId = values.segmentoId ? values.segmentoId.value : null;                
        caffenioUpdated.FechaApertura = values.FechaApertura ? moment(new Date(values.FechaApertura)).format("DD/MM/YYYY") : null;                 
        if (values.cerrado && values.FechaCierre)
            caffenioUpdated.FechaCierre= moment(new Date(values.FechaCierre)).format("DD/MM/YYYY");
        caffenioUpdated.CodigoPostal = puntoVenta["CP"];
        return caffenioUpdated
                
    }
   
    return (
        <Formik
            enableReinitialize
            initialValues={puntoVenta}
            validationSchema={GRAL_FIELDS}
            onSubmit={(values) => {
                let caffenioUpdated = mapValues(values);
                props.save(caffenioUpdated);
            }}>
            {({ values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                <form onSubmit={handleSubmit} id="frmInfoDriveStep">
                    {hrWithLegend('', false, 'left')}

                    {/* Nombre, cr, carriles*/}
                    <div className="columns is-multiline">
                        <div className="column is-12">
                            <Field label="Nombre" isHorizontal
                                hasError={errors.nombre != null}
                                msgError={errors.nombre ? errors.nombre : ""}
                            >
                                <input
                                    className="input"
                                    maxLength="50"
                                    label="Nombre"
                                    name="nombre"
                                    value={values.nombre}
                                    onChange={(e) => handleChange(e)}

                                />
                            </Field>
                        </div>

                        <div className="column is-6">
                            <Field label="Segmento" 
                                hasError={errors.segmentoId}
                                msgError={errors.segmentoId ? errors.segmentoId : ""}>
                                {
                                    <div className="column is-12">
                                        <Select
                                        placeholder={"Seleccionar..."}
                                        name={"segmentoId"}
                                        value={values.segmentoId}
                                        onChange={(val) => {
                                            setFieldValue('segmentoId', val)
                                            
                                            }}
                                        noOptionsMessage={() => "No hay opciones"}
                                        options={segmentos}
                                        isClearable 
                                        isDisabled={true}/>

                                    </div>
                                }
                            </Field>
                        </div>

                        <div className="column is-3">
                            <Field label="CR interno"
                                hasError={errors.crCaffenio}
                                msgError={errors.crCaffenio && errors.crCaffenio ? errors.crCaffenio : ""}>
                                <input
                                    className="input"
                                    label="crCaffenio"
                                    name="crCaffenio"                                    
                                    value={values.crCaffenio}
                                    onChange={(e) => handleChange(e)}

                                />
                            </Field>
                        </div>

                        <div className="column is-3">
                            <Field label="#Carriles"
                                hasError={errors.carriles}
                                msgError={errors.carriles ? errors.carriles : ""}>
                                <input
                                    className="input"
                                    type="number"
                                    min="0"
                                    label="carriles"
                                    name="carriles"
                                    maxLength="3"
                                    onKeyPress={onKeyPressNumber}
                                    value={values.carriles}
                                    onChange={(e) => handleChange(e)}
                                />
                            </Field>
                        </div>
                    </div>

                    
                    {values.segmentoId && FieldsBySegmento(values, errors,touched, handleChange, onKeyPressNumber)}
                    

                    {hrWithLegend('', false, 'left')}
                    {/* Booleans */}
                    <div className="columns is-multiline">
                        <div className="column is-3 margin-bottom">
                            <Field label="Activo" >
                                <input
                                    type="checkbox"
                                    name="activo"
                                    className="switch"
                                    checked={values.activo}
                                    onChange={(e) => { }}
                                />
                                <label htmlFor="activo" className="inputCenter" onClick={(e) => {
                                    e.stopPropagation(); 
                                    setFieldValue('activo', !values.activo)
                                }} />
                            </Field>
                        </div>
                        <div className="column is-3 margin-bottom">
                            <Field label="Ventas Móviles" isHorizontal={false} >
                                <input
                                    type="checkbox"
                                    name="ventasMovil"
                                    className="switch"
                                    checked={values.ventasMovil}
                                    onChange={() => { }}
                                />
                                <label htmlFor="ventasMovil" className="inputCenter" onClick={(e) => {
                                    e.stopPropagation();
                                    setFieldValue('ventasMovil', !values.ventasMovil)
                                }} />
                            </Field>
                        </div>
                        <div className="column is-3 margin-bottom">
                            <Field label="Restr. Refill"  >
                                <input
                                    type="checkbox"
                                    name="restrictRefill"
                                    className="switch"
                                    checked={values.restrictRefill}
                                    onChange={() => { }}
                                />
                                <label htmlFor="restrictRefill" className="inputCenter" onClick={(e) => {
                                    e.stopPropagation();
                                    setFieldValue('restrictRefill', !values.restrictRefill)
                                }} />
                            </Field>
                        </div>
                        
                        <div className="column is-3 margin-bottom">
                            <Field label="¿Está operando?">
                                <input
                                    type="checkbox"
                                    name="operando"
                                    className="switch"
                                    checked={values.operando}
                                    onChange={() => { }}
                                />
                                <label htmlFor="operando" className="inputCenter" onClick={(e) => {
                                    e.stopPropagation();
                                    setFieldValue('operando', !values.operando)
                                }} />
                            </Field>
                        </div>

                        <div className="column is-3 margin-bottom">
                            <Field label="Cerrado permanente" >
                                <input
                                    type="checkbox"
                                    name="cerrado"
                                    className="switch"
                                    checked={values.cerrado}
                                    onChange={() => { }}
                                />
                                <label htmlFor="cerrado" className="inputCenter" onClick={(e) => {
                                    e.stopPropagation();                                    
                                    if(!values.isClosed && !values.CloseDate){
                                        setFieldValue('CloseDate', Date.now());
                                    }
                                    setFieldValue('cerrado', !values.cerrado);
                                }} />
                            </Field>
                        </div>

                        <div className="column is-4">
                            <Field label="Fecha Apertura"
                                hasError={errors.FechaApertura }
                                msgError={errors.FechaApertura && touched.FechaApertura ? errors.FechaApertura : ""}>
                                <DatePicker
                                    name={"FechaApertura"}
                                    selected={values && values.FechaApertura ?  values.FechaApertura : ""}
                                    onChange={date => {
                                        setFieldValue('FechaApertura', date)
                                    }}
                                    popperPlacement="bottom"
                                    popperModifiers={{
                                        offset: {
                                            enabled: true,
                                            offset: '5px, 20px',
                                        },
                                        preventOverflow: {
                                            enabled: true,
                                            escapeWithReference: false,
                                            boundariesElement: 'viewport'
                                        }
                                    }}
                                    todayButton="Hoy"
                                    dateFormat="dd/MM/yyyy"
                                    className="input"
                                    autoComplete={"off"}
                                    //maxDate={values.FechaCierre}
                                />
                            </Field>

                        </div>
                        {values.cerrado && <div className="column is-4">
                            <Field label="Fecha Cierre"
                                hasError={errors.FechaCierre}
                                msgError={errors.FechaCierre && touched.FechaCierre ? errors.FechaCierre : ""}>
                                <DatePicker
                                    name={"FechaCierre"}
                                    selected={values && values.FechaCierre ? values.FechaCierre : ''}
                                    onChange={date => {
                                        setFieldValue('FechaCierre', date)
                                    }}
                                    popperPlacement="bottom"
                                    minDate={values.FechaCierre}
                                    popperModifiers={{
                                        offset: {
                                            enabled: true,
                                            offset: '50px, 10px'
                                        },
                                        preventOverflow: {
                                            enabled: true,
                                            escapeWithReference: false,
                                            boundariesElement: 'viewport'
                                        }
                                    }}
                                    todayButton="Hoy"
                                    dateFormat="dd/MM/yyyy"
                                    className="input"
                                    autoComplete={"off"}
                                />
                            </Field>

                        </div>}

                    </div>

                    <br />

                    <div className="has-text-left buttons-modal" id="stepActions">

                    </div>
                    <div className="has-text-right buttons-modal" id="stepActions">
                        <div className="pull-right">
                            <button id="btnSaveStepInfoDrive" type="submit" className="button is-light"  style={{marginRight:"5px"}} >Guardar y Continuar</button>
                            <button id="btnNextStepInfoDrive" type="button" className="button is-success" onClick={() => props.nextWithoutSave(mapValues(values))} >Siguiente</button>
                        </div>
                    </div>

                </form>
            )}

        </Formik>
    );

}

export default StepInfoDrive;